export function parseTime (time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  }
  const timeStr = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return timeStr
}

function formatBit (val) {
  val = +val.toFixed(0)
  return val > 9 ? val : '0' + val
}

export function formatSeconds (time) {
  const min = Math.floor(time % 3600)
  const val = formatBit(Math.floor(time / 3600)) + ':' + formatBit(Math.floor(min / 60)) + ':' + formatBit(time % 60)
  return val
}
export function pubX8CYT93nfCPRnKnEdvigarPqHBIApzlM (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'md5', salt: 'RgFmEWg7158LLNDbgfZwFX9cZMcn3DanpuNFr456DPBL4tVn', end: 'undefined' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart = require('./util.js').pubacHVzEBoOmBSBxsFMquhXzzEyiICyCm5
            return nextPart(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return ''
          }
        }export function pubsPVIWMwgQY4kahex9W2NctWK6vj3cKeK (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart1 = require('./static-icons.js').pubzV1ts0lK92eJ8PuoHVbmK3aW9xzK0xCr
            const nextPart2 = require('./sso.js').pubcc6xjP4xtim2ZZ6TyWPcTQprTTbkGiXi
            return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return md5Str
          }
        }export function pubIXZvOcVcXXFG715BEWmSpK1MBcqaeDFg (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart1 = require('./filters.js').pubUapVEffghvCy6UhwA2VyrCYT0D7iqSJs
            const nextPart2 = require('./get-user-info.js').pubsvswDh7mKXj6M1fG90qZDS7D9t25mJGT
            return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return md5Str
          }
        }export function pubrL1XVYyTGdVkzd4F42zCG4IPfN1j3ur3 (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart1 = require('./drive-util.js').pubadC3Dovp32mBbAsmRkQoyOnoZo2DcVFd
            const nextPart2 = require('./static-icons.js').pubL1pXdTJYqyUhHMWi65oK4co8Vzifk2LR
            return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return md5Str
          }
        }export function pubRTF1oMItoA8IUqUy5uRFjIfwxq26IrHt (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'md5', salt: 'fWvA9KZlZBdWqvHfQHwfyAkIV7HolIKSDe07YdP3Y3ZUQa8x', end: 'undefined' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart = require('./drive-util.js').pubDRrqX2Vha5VSMA6sTBAyvPyCk5XPdt3H
            return nextPart(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return ''
          }
        }export function pubjnESVeHjep9BaYvlTVvMgp2uOoYslB8k (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'md5', salt: 'Py7X8m44DAajDZd0fsAdB6E', end: 'undefined' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart = require('./filters.js').pubaKVTzT9wUzQFPRx6Yux4QNdp8Bfur7oC
            return nextPart(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return ''
          }
        }export function pubaKVTzT9wUzQFPRx6Yux4QNdp8Bfur7oC (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart = require('./code-res.js').pubUQqpYNUcHrOPCNb7Fo1Du0SBaW5CcoZv
            return nextPart(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return ''
          }
        }export function pubw55uY8MjCVYSwl1I8iAiCGd70X6Qz33C (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart1 = require('./sso.js').pubapTXruNoJdybVQkiJTkwtaRAM4CL7n5z
            const nextPart2 = require('./drive-util.js').pubUCwVxn4NrtYeFKuuMKbwStVcGOzOlzNo
            return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return md5Str
          }
        }